<script lang="ts" setup>
var props = defineProps({
  progress: {
    type: Number,
    default: 0,
  },
});

var width = computed(() => {
  return props.progress * 100 + "%";
});

</script>

<template>
  <div class="rounded-full h-[16px] border overflow-clip">
    <div class="bg-primary-default h-full transition-[width]" :style="{ width }"></div>
  </div>
</template>

<style scoped></style>
